import React from 'react'
import styled from 'styled-components'
import { StickyBottomStrip, Price, Typography } from '../../../Common'
import { AddToBasket } from '../AddToBasket'
import {
  usePrice,
  useProductState,
  useProductFunctions,
  useConfigState,
} from '@sentecacommerce-theme/lib'

export const MobileStickyAddToBasket = ({
  show,
  onAddToBasketClick,
}: {
  show: boolean
  onAddToBasketClick?: () => void
}) => {
  const config = useConfigState()
  const { selectedVariant, metaData } = useProductState()
  const { getCustomFieldValue } = useProductFunctions()

  const offer = selectedVariant?.offer

  const hideRegularPrice = getCustomFieldValue(
    config.customFieldKeys.hideRegularPrice
  )

  const getPrice = () => {
    if (!hideRegularPrice) return offer?.originalPrice

    if (offer?.discountedPrice?.centAmount) return offer?.discountedPrice

    return offer?.originalPrice
  }

  const { price, discountPrice } = usePrice({
    price: getPrice(),
    discountedPrice: !hideRegularPrice ? offer?.discountedPrice : undefined,
  })

  return (
    <StickyBottomStrip show={show} mobile>
      <Container>
        <Header>
          <MetaName>{metaData.name}</MetaName>
          <PriceContainer>
            <Price
              hideDiscountPercentage
              size="small"
              price={price.value}
              discountedPrice={discountPrice ? discountPrice.value : undefined}
              hideRegularPrice={hideRegularPrice}
              currency={price.currency}
            />
          </PriceContainer>
        </Header>
        <AddToBasket onClick={onAddToBasketClick} />
      </Container>
    </StickyBottomStrip>
  )
}

const MetaName = styled(Typography).attrs({
  variant: 7,
})`
  color: ${({ theme }) => theme.palette.greyTitle};
  line-height: '1.4';
`

const Header = styled.div.attrs({
  className: 'd-flex justify-content-between align-items-end mb-4 mt-3',
})`
  & > p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2;
  }
  & > div {
    padding-left: 2rem;
  }
`

const Container = styled.div.attrs({
  className: 'd-lg-none',
})`
  width: 100%;
  background-color: ${({ theme }) => theme.palette.secondary};
  z-index: 1000;

  & > div {
    padding: 0 !important;
  }
`
const PriceContainer = styled.div.attrs({ className: 'ml-3' })`
  font-weight: 550;
  padding-bottom: 0.18rem;
  color: ${({ theme }) => theme.palette.greyTitle};
`
